import { APIProvider, Map, MapProps } from '@vis.gl/react-google-maps';

export const GoogleMap = (props: MapProps) => {
    return <Map defaultZoom={15} gestureHandling={'greedy'} disableDefaultUI={true} {...props} />;
};
